<template>
  <div class="wysiwyg">
    <p>
      We are unable to accept a self referral as you are not registered with a GP within NHS Greater Glasgow and Clyde. Your GP may be able to refer you to us or to your local department.  Please consult them to discuss this.
    </p>
  </div>
</template>

<script>
export default {
  name: "NotRegisteredWithGP",
};
</script>